import { ApolloClient, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import process from 'process';

let isDev = !process.env.NODE_ENV || process.env.NODE_ENV === 'development';

export const host = "";// isDev ? "localhost:4000" : "pvplevelup.com"//"pvplevelup.com";
export const protocol = ""//isDev ? "http://" : "https://";
//const wsprotocol = "wss:";
export const clientVersion = "3.0.1";
export const SCHEMA_VERSION = '25';
export const SCHEMA_VERSION_KEY = 'apollo-schema-version';

const cache = new InMemoryCache();

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem('token');
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      //authToken: token,
      clientVersion: clientVersion
    },
    
  }
});

const public_url = `${host}/api/v1/ql`;
const httpLink = createHttpLink({
  uri: protocol + public_url
});
  
  const httpApolloClient = new ApolloClient({
    link: authLink.concat(httpLink),
    cache
  });


  export {httpApolloClient};